import InlineNotice from './InlineNotice';

export default InlineNotice;
